enum SetupType {
    Store = "setup/STORE",
}

export default SetupType;
